// extracted by mini-css-extract-plugin
export default {"backdrop":"CartModal_backdrop__LHH0z","cartContainer":"CartModal_cartContainer__xCv88"};